//监听扫码
import router from "@/router/router";
// import {scanPreTask} from "@/api/preTask";
// import store from "@/store";
// import {message} from "@/api/resetMessage";
import EventBus from "@/ws/eventBus";
export default {
  barCode:'',
  lastTime:"",
  listenScanCodeGun() {
    // console.log('开始监听了')
    let self = this;
    // var barCode = '';
    // var lastTime = 0;
    function ClearBarCode() {
      this.barCode = '';
      this.lastTime = 0;
    }
    window.addEventListener('keypress', (e) => {
      e = e || window.event;
      var currCode = e.keyCode || e.which || e.charCode;
      var currTime = new Date().getTime();
      // console.log(this.barCode,currCode,'sssss')
      if (currCode == 13) {
        // 回车
          // 这里得到码，做下一步业务处理
          // console.log('最终编号：' + this.barCode);
          self.autoCreate(this.barCode);
          this.barCode = ''
          this.lastTime = 0
          // if (!self.hasScanCodeList.includes(barCode) && !self.submitLoading) {
          //   self.autoCreate(barCode);
          // }
        // 回车输入后清空

      }else {
        // this.barCode = ''
      }
      this.barCode += String.fromCharCode(currCode);
      this.lastTime = currTime;
    });
  },
  autoCreate (barCode){
    if (router.currentRoute.path == '/preTask'){
      EventBus.$emit('autoCreatePre',barCode)
    }else if (router.currentRoute.path == '/tasks'){
      EventBus.$emit('autoCreate',barCode)
    }
  },
    removeListen(){
    window.removeEventListener('keypress',(e) => {
      e = e || window.event;
    },false)
    }
}
